import * as api from '../resources/documents.api';
import actionTypes from './action-types';

export const prefetchDocumentRequest = () => ({
  type: actionTypes.PREFETCH_DOCUMENT_REQUEST,
});

export const prefetchDocumentSuccess = () => ({
  type: actionTypes.PREFETCH_DOCUMENT_SUCCESS,
});

export const prefetchDocument = (id) => async (dispatch) => {
  dispatch(prefetchDocumentRequest());

  dispatch(prefetchDocumentSuccess());
  return await api.prefetchDocument(id);
};



// WEBPACK FOOTER //
// ./src/modules/documents/actions/prefetch-document.actions.js